// src/components/documentos/TemplateGrid.jsx

import React from "react";
import { LayoutTemplate } from "lucide-react";
import TemplateCard from "./TemplateCard";
import { getTemplatesByType } from "../../templates/index";

export default function TemplateGrid({
  activeType,
  sortBy,
  activeId,
  onSelect,
  onEdit,
  onPreview,
}) {
  const templates = getTemplatesByType(activeType, sortBy);

  // ── Estado vacío ────────────────────────────────────────────────────────────
  if (templates.length === 0) {
    return (
      <div className="tpl-empty">
        <LayoutTemplate size={40} strokeWidth={1.2} />
        <p>No hay plantillas para este tipo de documento.</p>
      </div>
    );
  }

  // ── Grid ────────────────────────────────────────────────────────────────────
  return (
    <div className="tpl-grid">
      {templates.map((tpl) => (
        <TemplateCard
          key={tpl.id}
          template={tpl}
          isActive={tpl.id === activeId}
          onSelect={onSelect}
          onEdit={onEdit}
          onPreview={onPreview}
        />
      ))}
    </div>
  );
}
